export const environment = {
  production: false,
  version: "test-env",
  staticsPath: "/",
  nsBusinessUrl: "/",
  nsBusinessUrlEnglish: "/",
  leadsApiBaseUrl: "https://api.zakelijke-pakketten.nszakelijk-o.cla.ns.nl/leads",
  api: {
    mock: false,
    delayTime: 500,
    randomizeDelayTime: true,
  },
  optimizelySdk: "",
  avo: {
    enabled: false,
    apiKey: "",
    appVersion: "1.0.0",
    appName: "Zakelijke pakketten",
  },
};
